import { ChangeEvent, FC, useState } from 'react'
import {
  Button,
  FilterButton,
  Flex,
  Header,
  Popup,
  PopupProps,
  TextArea,
  VStack,
} from '@revolut-internal/ui-kit'

import { feedbackReasons } from './ChatMessageFeedbackPopup.constants'

interface IChatMessageFeedbackPopupProps extends Pick<PopupProps, 'open' | 'onClose'> {
  onSubmit: (feeback: string, reasons: string[]) => void
  isLoading: boolean
}

export const ChatMessageFeedbackPopup: FC<IChatMessageFeedbackPopupProps> = ({
  open,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const [feedback, setFeedback] = useState('')
  const [selectedReasons, setSelectedReasons] = useState<string[]>([])

  const handleOnFeedbackChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setFeedback(event.target.value)
  }

  const handleOnSelectReason = (reason: string) => {
    setSelectedReasons(prevState =>
      prevState.includes(reason)
        ? prevState.filter(feedbackReason => feedbackReason !== reason)
        : [...prevState, reason],
    )
  }

  const handleSubmit = () => {
    onSubmit(feedback, selectedReasons)
    onClose?.()
  }

  return (
    <Popup variant="modal-view" open={open} onClose={onClose} labelButtonClose="Close">
      <Header variant="compact">
        <Header.CloseButton aria-label="Close" onClick={onClose} />
        <Header.Title>What went wrong?</Header.Title>
      </Header>
      <VStack space="s-16">
        <VStack space="s-16">
          <Flex flexWrap="wrap">
            {feedbackReasons.map(reason => (
              <FilterButton
                data-event-key={reason}
                key={reason}
                onClick={() => handleOnSelectReason(reason)}
                active={selectedReasons.includes(reason)}
                aria-haspopup="listbox"
                mr="s-8"
                mb="s-8"
              >
                {reason}
              </FilterButton>
            ))}
          </Flex>

          <VStack space="s-24">
            <TextArea
              label="Your feedback"
              rows={2}
              onChange={handleOnFeedbackChange}
              value={feedback}
            />
          </VStack>
        </VStack>
      </VStack>
      <Popup.Actions>
        <Button variant="primary" elevated pending={isLoading} onClick={handleSubmit}>
          Submit
        </Button>
      </Popup.Actions>
    </Popup>
  )
}
